module.exports = __webpack_public_path__ + "img/124.485fe33f.jpg";